module.exports = ".example-dropdown {\r\n    width: 250px;\r\n\r\n    .bolt-button {\r\n        width: 250px;\r\n    }\r\n}\r\n"